import React from 'react';
import { Table } from 'antd';
import { NameOf, TableExpressions } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TransactionTypeDTO from 'src/models/generated/TransactionTypeDTO';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';

export interface TransactionTypeTableProps {
    data?: TransactionTypeDTO[];
    loading?: boolean;
    filterStrings: string[];
}

const TransactionTypeTable: React.FC<TransactionTypeTableProps> = (props) => {
    const tableColumns: ColumnProps<TransactionTypeDTO>[] = [
        TableColumnBuilder.Create<TransactionTypeDTO>('transactionType', 'Transaction Type')
            // .Width(400)
            .AddSorter('Text')
            .AddRenderer('Ellipses')
            .AddEnumFilterer(props.filterStrings, 'Exact Text')
            .Build(),
        TableColumnBuilder.Create<TransactionTypeDTO>('transactionDate', 'Transaction Date')
            // .Width(400)
            .AddSorter('Date')
            .AddRenderer('ShortDate', false)
            .AddDateFilterer()            
            .Build(),
        TableColumnBuilder.Create<TransactionTypeDTO>('transactionId', 'Transaction Id')
            // .Width(400)
            .AddSorter('Text')
            .AddRenderer('Ellipses')
            .AddTextFilterer()
            .Build(),
        TableColumnBuilder.Create<TransactionTypeDTO>('transactionReference', 'Transaction Reference')
            // .Width(400)
            .AddSorter('Text')
            .AddRenderer('Ellipses')
            .AddTextFilterer()
            .Build(),
        TableColumnBuilder.Create<TransactionTypeDTO>('nameId', 'Name Id')
            // .Width(400)
            .AddSorter('Text')
            .AddRenderer('Ellipses')
            .AddTextFilterer()
            .Build(),
        TableColumnBuilder.Create<TransactionTypeDTO>('name', 'Name')
            // .Width(400)
            .AddSorter('Text')
            .AddRenderer('Ellipses')
            .AddTextFilterer()
            .Build(),
        TableColumnBuilder.Create<TransactionTypeDTO>('amount', 'Amount')
            // .Width(400)
            .AddSorter('Number')
            .AddRenderer('Currency')
            .AddCurrencyFilterer()
            .Align('right')
            .Build()
    ];
    //TableColumnBuilder.Create<TransactionTypeDTO>('modified', 'Modified')
    //  // .Width(400)
    //  .AddSorter('Text')
    //  .AddRenderer('Ellipses')
    //  .AddTextFilterer()
    //  .Build(),
    //];

    return <>
        <Table
            rowKey={NameOf<TransactionTypeDTO>('id')}
            className='condensed-table striped-table'
            rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
            loading={props.loading}
            pagination={false}
            columns={tableColumns}
            dataSource={props.data}
        />
    </>;
};

export default TransactionTypeTable;
